module.exports = __webpack_public_path__ + "media/images/icons/calculator-deeaf77080061dee38ae3fb0f22c2350.svg";